<template>
  <div>
    <toolbar-loader v-if="loading"></toolbar-loader>

    <service-card
      class="mb-3"
      v-for="service in services" :key="service.id"
      :scope="scope"
      :service="service">
    </service-card>

    <template v-if="$can('update', 'services')">
      <v-btn
        v-if="isOfferScope"
        floating error light
        class="fixed"
        router :href="{ name: 'ServiceCreation' }">
        <v-icon light>add</v-icon>
      </v-btn>
      <v-btn
        v-else
        floating error light
        class="fixed"
        :loading="pageCreation"
        @click.native.stop="createPage">
        <v-icon light>add</v-icon>
      </v-btn>
    </template>
  </div>
</template>

<script>
  import Service from '@/api/service'
  import { mapActions, mapGetters } from 'vuex'
  import ToolbarLoader from '@/components/ToolbarLoader.vue'
  import ServiceCard from '@/components/service/Card'
  export default {
    components: {
      ToolbarLoader,
      ServiceCard
    },
    props: {
      scope: {
        type: String,
        default: 'public'
      }
    },
    data () {
      return {
        pageCreation: false
      }
    },
    computed: {
      ...mapGetters({
        loading: 'skiliko/services/isLoading',
        servicesByScope: 'skiliko/services/servicesByScope'
      }),
      services () { return this.servicesByScope[this.scope] || [] },
      isOfferScope () { return Service.isOfferScope(this.scope) }
    },
    watch: {
      scope () { this.fetchAll({ scope: this.scope }) }
    },
    methods: {
      ...mapActions({
        fetchAll: 'skiliko/services/fetchAll',
        _createPage: 'skiliko/services/create'
      }),
      createPage () {
        this.pageCreation = true
        this._createPage({ data: {
          service_type: this.scope,
          price: 0
        } })
          .then(x => {
            this.pageCreation = false
            this.$router.push({ name: 'Service', params: x })
          })
          .catch(x => {
            this.pageCreation = false
            throw x
          })
      }
    },
    mounted () {
      this.fetchAll({ scope: this.scope })
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Services.vue